import _ from "lodash";
import React, { useEffect, useContext, useState } from "react";
// data and utility
import Data from "../../../../data";
import Util from "../../../../util"
// context
import {CatalogueContext, ShopContext} from "../../../../context";

// components
import NotFound from "./NotFound";
import {Block, HtmlHeader, Scaffolding} from "../../../shared";
import {Link, Money, Button} from "../../../controls"
import {Redirect} from "react-router-dom"

// styling
import "./ActivityPackage.scss";

export default function ActivityPackage(props) {
  // context
  const CC = useContext(CatalogueContext);
  const SC = useContext(ShopContext)

  // get the slug (provided by router)
  const slug = props.match.params.slug;

  // state
  const [activityPackage, setActivityPackage] = useState(null);
  const [activities, setActivities] = useState([]);
  const [selectedRegionVariant, setSelectedRegionVariant] = useState(null);
  const [selectedPriceConfiguration, setSelectedPriceConfiguration] = useState(null);
  const [cheapestPriceConfiguration, setCheapestPriceConfiguration] = useState({participantCount:1, price:10});
  const [availableRegions, setAvailableRegions] = useState([]);
  const [redirectToCart, setRedirectToCart] = useState(false);
  const [packageNotFound, setPackageNotFound] = useState(false);
  
  // scroll to top when mounting
  useEffect(() => {
    Util.Scroll.scrollToTop()
  }, [slug])

  // process side effects
  useEffect(() => {
    if(CC.isReady) {
      // retrieve the activity package and add to state
      let activityPackage = Data.ActivityPackages.getBySlug(slug);

      // set states depending on whether the package was found nor not
      if(!activityPackage) {
        setPackageNotFound(true);
      }
      else {
        // find included activities
        let activities = [];
        if(activityPackage) {
          activities = activityPackage.activities
            .map(a => {
              const catalogueActivity = CC.activities.all.find(ca => ca._id === a.activityId) || null;
              const packageActivity = a;
              return {
                catalogueActivity, packageActivity
              }
            })
            .filter(a => a.catalogueActivity !== null)
            .sort((a,b) => a.packageActivity.sortIndex - b.packageActivity.sortIndex);
        }
        // find lowest price
        const cheapestPriceConfiguration = Data.ActivityPackages.getMinMaxPriceConfiguration(activityPackage).min;

        // available regions
        const availableRegions = activityPackage.regionVariants.map(rv => {
          return Data.Regions.getTitle(rv.regionCode, "de").replace("Region", "").trim();
        }).sort((a,b) => a.localeCompare(b));
        setAvailableRegions(availableRegions);

        // set state
        setActivities(activities);
        setActivityPackage(activityPackage);
        const region = Data.Cart.getAdventureRegion() || Data.Regions.get()[0];
        const regionVariant = activityPackage.regionVariants.find(rv => rv.regionCode === region.code) || activityPackage.regionVariants[0];
        setSelectedRegionVariant(regionVariant);
        setSelectedPriceConfiguration(regionVariant.priceConfigurations.find(pc => pc.price !== 0));
        setCheapestPriceConfiguration(cheapestPriceConfiguration);
      }
    }
    
  }, [slug, CC.isReady, CC.activities]);
  
  // redirect to cart?
  if(redirectToCart) {
    return <Redirect to="/checkout" />
  }


  
  // catalogue and other data still loading?
  // TODO why check that here again? we already check this in the useEffect above
  if(!CC.isReady) {
    return null;
  }

  // no activity package with that slug?
  if(packageNotFound) {
    return <NotFound />;
  }

  // package not yet loaded?
  if(!activityPackage) {
    return null;
  }


  // use wants to add to cart
  const onClickAddToCart = () => {
    // TODO this should really be part of SC.cart ... but considering next is coming soon I cannot be bothered

    // remove all activities
    SC.cart.removeAllActivities();

    // add the package activities
    activityPackage.activities.forEach(a => {
      // get the activity
      const activity = Data.Catalogue.getActivityById(a.activityId);

      // region code - we can only use the selected region if the activity has that region available
      let regionCode = undefined;
      if((activity.regions || []).includes(selectedRegionVariant.regionCode)) {
        regionCode = selectedRegionVariant.regionCode;
      }
      else {
        // use the activity's default
        regionCode = Data.Activity.getDefaultRegionCode(activity);
      }

      // participant count
      let participantCount = Data.Activity.getDefaultParticipantCount(activity._id, regionCode);
      let possibleParticipants = Data.Activity.getPriceConfigurations(activity, regionCode).map(pc => pc.participantCount)
      if(possibleParticipants.includes(selectedPriceConfiguration.participantCount)) {
        // if the selected participant count is possible, we use that
        participantCount = selectedPriceConfiguration.participantCount;
      }

      // add 
      const options = [];
      const subactivities = [];
      SC.cart.addActivity(activity, regionCode, options, participantCount, subactivities);
    })

    setRedirectToCart(true);
    
  }

  // user selects region variant
  const onChangeRegionVariant = (rv) => {
    setSelectedRegionVariant(rv);
    setSelectedPriceConfiguration(rv.priceConfigurations[0]);
  }

  // user selects price configuration
  const onChangePriceConfiguration = (pc) => {
    setSelectedPriceConfiguration(pc);
  }

  // pre-render 
  // seo values for helmet and
  let seo_title = `${activityPackage.title} - Appentura`;
  let seo_image = _.get(activityPackage, "image.url");
  
  // render
  return (
    <Scaffolding>
      <div id="v-activitypackage">
        <HtmlHeader title={seo_title} imageUrl={seo_image || ""} />
        <Block>
          <div className="container boxshadow">

            <div className="info">
              <div className="info-image">
                <div className="image-container">
                  <img src={activityPackage.image.url} alt={activityPackage.title} />
                </div>
              </div>

              <div className="info-info">
                <div className="title">
                  <h1>{activityPackage.title}</h1>
                </div>
                <div className="shortDescription">
                  <p>{activityPackage.shortDescription}</p>
                </div>
                <div className="longDescription">
                  {activityPackage.longDescription.split("\n").map((s, index) => <p key={index}>{s}</p>)}
                </div>
                <div className="regions">
                  <span>Verfügbar in:</span> {availableRegions.join(', ')}
                </div>
                <div className="price">
                  ab <Money amount={cheapestPriceConfiguration.price} /> für {cheapestPriceConfiguration.participantCount} Teilnehmer
                  
                </div>
                <div className="actions">
                  <div className="action">
                    <div className="action-title">Region wählen</div>
                    <SelectRegion regionVariant={selectedRegionVariant} activityPackage={activityPackage} onChange={onChangeRegionVariant} />
                  </div>
                  <div className="action">
                    <div className="action-title">Anzahl Teilnehmer wählen</div>
                    <SelectPriceConfiguration regionVariant={selectedRegionVariant} priceConfiguration={selectedPriceConfiguration} onChange={onChangePriceConfiguration} />
                  </div>
                  <div className="action">   
                    <Button 
                      label="in den Warenkorb"
                      onClick={onClickAddToCart}
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="activities">
              <div className="activities-inner">
                <div className="activities-title">
                  <h2>Enthaltene Erlebnisse</h2>
                </div>
                <div className="activities-items">
                  {
                    activities.map((a,index) => <Activity key={index} packageActivity={a.packageActivity} catalogueActivity={a.catalogueActivity}  />)
                  }
                </div>
              </div>
            </div>
            
          </div>
        
        </Block>
        
      </div>
    </Scaffolding>
  )
}

function SelectRegion({activityPackage, regionVariant, onChange}) {
  // on change of selected region variant
  const _onChange = (regionCode) => {
    const rv = activityPackage.regionVariants.find(rv => rv.regionCode === regionCode);
    onChange(rv);
  }

  // pre-render
  const items = Data.Regions.get()
    .filter(r => {
      return activityPackage.regionVariants.some(rv => rv.regionCode === r.code);
    })
    .sort((a, b) => {
      let na = Data.Regions.getTitle(a.code, "de");
      let nb = Data.Regions.getTitle(b.code, "de");
      return na.localeCompare(nb);
    })
    .map(r => {
      return (
        <option key={r.code} value={r.code}>
          {Data.Regions.getTitle(r.code, "de")}
        </option>
      )
    })
  // render 
  return <div>
    <select value={regionVariant.regionCode} onChange={e => _onChange(e.target.value)}>
      {items}
    </select>
  </div>
}

function SelectPriceConfiguration({regionVariant, priceConfiguration, onChange}) {
  // on change of select
  const _onChange = (participantCount) => {
    const pc = regionVariant.priceConfigurations.find(pc => pc.participantCount === participantCount);
    onChange(pc);
  }
  
  // pre-render
  const items = regionVariant.priceConfigurations
  .filter(pc => pc.price > 0)
  .map(pc => {
    return <option value={pc.participantCount} key={pc.participantCount}>{pc.participantCount} Teilnehmer, {Util.Format.currency(pc.price, true)}</option>
  })
  // render
  return <div>
    <select value={priceConfiguration.participantCount} onChange={e => _onChange(Number(e.target.value))}>
      {items}
    </select>
  </div>
}


function Activity({catalogueActivity, packageActivity}) {
  return <div className="activities-item">
    <div className="left">
      <div className="image">
        <img src={packageActivity.image.url} alt={catalogueActivity.title} />
      </div>
    </div>
    <div className="right">
      <div className="title">{packageActivity.title}</div>
      <div className="description">{packageActivity.description}</div>
      <div className="activity">
        <Link to={`/activity/${catalogueActivity.slug}`}>
          {catalogueActivity.title}
        </Link>
      </div>
    </div>
    
  </div>
}